import { useCallback, useContext, useState } from 'react';

import ToastContext from 'Context/ToastContext';

import { useToast } from 'Hooks/useToast';

const useMutation = ({ mutationFn, displayErrorToast = true, errorMessage, successMessage } = {}) => {
    const [data, setData] = useState(null);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    const toast = useContext(ToastContext) ? useToast() : null;

    /**
     * Makes an API mutate with the given options
     */
    const mutate = useCallback(
        async (data) => {
            setLoading(true);
            setError(null);

            try {
                const response = await mutationFn(data);

                setData(response.data);

                if (toast && successMessage) {
                    toast.success(successMessage);
                }

                return Promise.resolve(response);
            } catch (err) {
                setError(err);

                if (toast && displayErrorToast) {
                    toast.error(errorMessage || err.response?.data?.message || err.response?.data?.error || $t('An error occurred, please try again'));
                }

                return Promise.reject(err);
            } finally {
                setLoading(false);
            }
        },
        [mutationFn, toast, displayErrorToast, errorMessage, successMessage],
    );

    return { mutate, data, loading, error };
};

export default useMutation;
